/* IC CALCULATOR IMPROVEMENTS v1.1 — NO ONBOARDING MODAL */
(function() {
  'use strict';

  function whenReady(fn) {
    if (typeof METHODS !== 'undefined' && typeof state !== 'undefined' && typeof update === 'function') {
      fn();
    } else {
      setTimeout(function() { whenReady(fn); }, 50);
    }
  }

  whenReady(function() {
    // FIX #1: BLOOM RATIO UNIFORM
    if (METHODS.aeropress) METHODS.aeropress.bloomMul = 2;
    if (METHODS.clever) METHODS.clever.bloomMul = 2;

    // FIX #2: TIME SCALING WITH CUPS
    METHODS.v60.timeScale = 30;
    METHODS.chemex.timeScale = 45;
    METHODS.aeropress.timeScale = 15;
    METHODS.frenchpress.timeScale = 0;
    METHODS.clever.timeScale = 30;
    METHODS.moka.timeScale = 60;
    METHODS.coldbrew.timeScale = 0;
    METHODS.espresso.timeScale = 0;

    function timeStrToSec(s) {
      if (typeof s !== 'string') return 0;
      var m = s.match(/^(\d+):(\d+)$/);
      if (m) return parseInt(m[1]) * 60 + parseInt(m[2]);
      return 0;
    }
    function secToTimeStr(sec) {
      var mm = Math.floor(sec / 60);
      var ss = sec % 60;
      return mm + ':' + (ss < 10 ? '0' : '') + ss;
    }

    var _origCalc = window.calc;
    window.calc = function() {
      var r = _origCalc();
      var m = METHODS[state.method];
      var cups = state.cups || 1;
      if (cups > 1 && m && m.type === 'filter' && m.timeScale && typeof r.time === 'string') {
        var baseSec = timeStrToSec(r.time);
        if (baseSec > 0) {
          var newSec = baseSec + (cups - 1) * m.timeScale;
          r.time = secToTimeStr(newSec);
        }
      }
      return r;
    };

    // FIX #3: TOOLTIPS
    function addTooltip(targetSelector, content) {
      var el = document.querySelector(targetSelector);
      if (!el || el.dataset.tooltipped === '1') return;
      el.dataset.tooltipped = '1';
      var wrap = document.createElement('span');
      wrap.className = 'ic-info-tooltip';
      wrap.setAttribute('tabindex', '0');
      wrap.setAttribute('role', 'button');
      wrap.setAttribute('aria-label', 'Informație');
      wrap.innerHTML = '?<span class="ic-tooltip-content">' + content + '</span>';
      el.parentNode.insertBefore(wrap, el.nextSibling);
    }

    var styleEl = document.createElement('style');
    styleEl.textContent =
      '.ic-info-tooltip{display:inline-flex;align-items:center;justify-content:center;width:16px;height:16px;border-radius:50%;background:#C9A96E;color:#1A1612;font-size:11px;font-weight:700;cursor:help;position:relative;margin-left:6px;font-family:Lato,sans-serif;vertical-align:middle}'+
      '.ic-info-tooltip:hover .ic-tooltip-content,.ic-info-tooltip:focus .ic-tooltip-content{opacity:1;visibility:visible;transform:translateX(-50%) translateY(0)}'+
      '.ic-tooltip-content{position:absolute;bottom:calc(100% + 8px);left:50%;transform:translateX(-50%) translateY(4px);background:#1A1612;color:#F5F0E8;padding:12px 16px;border-radius:4px;font-size:12px;font-weight:400;line-height:1.5;width:240px;z-index:100;opacity:0;visibility:hidden;transition:all .2s ease;pointer-events:none;text-transform:none;letter-spacing:.01em}'+
      '.ic-tooltip-content strong{color:#C9A96E;font-weight:700}'+
      '.ic-taste-advice{margin-top:18px;padding:16px 20px;background:rgba(201,169,110,.08);border-left:3px solid #C9A96E;border-radius:2px;font-size:13px;line-height:1.7}'+
      '.ic-taste-advice-title{font-size:11px;font-weight:900;letter-spacing:.15em;text-transform:uppercase;color:#C9A96E;margin-bottom:8px}'+
      '.ic-taste-advice ul{list-style:none;padding:0;margin:0}'+
      '.ic-taste-advice li{padding:4px 0;color:rgba(26,22,18,.85)}'+
      '.ic-taste-advice li strong{color:#1A1612;font-weight:700}';
    document.head.appendChild(styleEl);

    function injectTooltips() {
      addTooltip('.science-stat:nth-child(1) .science-label',
        '<strong>EY · Extraction Yield</strong><br>Cât din cafeaua ta s-a transformat în lichid.<br><strong>18-22% = sweet spot.</strong><br>Sub 18% = subextras (acid, fad). Peste 22% = suprextras (amar, plat).');
      addTooltip('.science-stat:nth-child(2) .science-label',
        '<strong>TDS · Total Dissolved Solids</strong><br>Cât de concentrată e cafeaua.<br>Filtru = ~1.2-1.5%, espresso = ~9-10%.<br>Mai mare = mai intens, mai mic = mai diluat.');
    }
    setTimeout(injectTooltips, 200);

    // FIX #4: TASTE ADVICE
    function generateTasteAdvice() {
      if (typeof predictTaste !== 'function') return null;
      var taste = predictTaste();
      var r = window.calc();
      if (typeof r.temp !== 'number') return null;
      var tips = [];
      if (taste.status === 'sweet') {
        return { title: 'Toate parametrii sunt în zona dulce', tips: ['Cafeaua ta ar trebui să gustă echilibrat. Schimbă un singur lucru dacă vrei să explorezi: macinarea cu o treaptă sau temperatura cu 1°C.'] };
      }
      if (taste.acidity > 0.5 || taste.status === 'cold') tips.push('Vrei <strong>mai puțin acid</strong>? → Macină cu o treaptă mai fin SAU crește temperatura cu 1°C.');
      if (taste.bitterness > 0.5 || taste.status === 'hot') tips.push('Vrei <strong>mai puțin amar</strong>? → Macină cu o treaptă mai grosier SAU scade temperatura cu 1°C.');
      if (taste.sweetness < -0.5) tips.push('Vrei <strong>mai dulce</strong>? → Reduce temperatura cu 1°C SAU macină puțin mai grosier.');
      if (taste.body < -0.5) tips.push('Vrei <strong>mai mult corp</strong>? → Folosește mai puțină apă (raport 1:14-1:15) SAU macină puțin mai fin.');
      if (taste.body > 0.8) tips.push('Cafeaua e <strong>foarte plină</strong>. Dacă vrei mai delicat → mai multă apă (raport 1:17) sau mai grosier.');
      if (tips.length === 0) tips.push('Profil aproape de recomandat — ajustări minime pot rafina rezultatul.');
      return { title: 'Cum ajustezi data viitoare', tips: tips };
    }

    function injectTasteAdviceUI() {
      var summaryEl = document.getElementById('tasteSummary');
      if (!summaryEl || document.getElementById('icTasteAdvice')) return;
      var advice = document.createElement('div');
      advice.id = 'icTasteAdvice';
      advice.className = 'ic-taste-advice';
      advice.innerHTML = '<div class="ic-taste-advice-title">Cum ajustezi data viitoare</div><ul id="icTasteAdviceList"></ul>';
      summaryEl.parentNode.insertBefore(advice, summaryEl.nextSibling);
    }

    function updateTasteAdvice() {
      var advice = generateTasteAdvice();
      var listEl = document.getElementById('icTasteAdviceList');
      var titleEl = document.querySelector('#icTasteAdvice .ic-taste-advice-title');
      var wrapEl = document.getElementById('icTasteAdvice');
      if (!listEl || !wrapEl) return;
      if (!advice) { wrapEl.style.display = 'none'; return; }
      wrapEl.style.display = 'block';
      if (titleEl) titleEl.textContent = advice.title;
      listEl.innerHTML = advice.tips.map(function(t) { return '<li>' + t + '</li>'; }).join('');
    }

    var _origUpdate = window.update;
    window.update = function() {
      _origUpdate.apply(this, arguments);
      try { updateTasteAdvice(); } catch (e) {}
      try { updateHowToSchema(); } catch (e) {}
    };

    // FIX #5: DYNAMIC HOWTO SCHEMA
    function updateHowToSchema() {
      if (!METHODS[state.method] || METHODS[state.method].type !== 'filter') {
        var existing = document.getElementById('icHowToSchema');
        if (existing) existing.remove();
        return;
      }
      var o = ORIGINS[state.origin];
      var m = METHODS[state.method];
      var r = window.calc();
      var sb = (typeof brewStages === 'function') ? brewStages() : null;
      var steps = [];
      if (sb && sb.stages) steps = sb.stages.map(function(s) { return { '@type': 'HowToStep', 'name': s.name, 'text': s.detail }; });
      var schema = {
        '@context': 'https://schema.org',
        '@type': 'HowTo',
        'name': 'Cum prepari cafea ' + m.name + ' cu ' + o.name + ' — rețetă Incognito',
        'description': 'Rețetă personalizată pentru ' + o.name + ' (' + o.region + ') folosind metoda ' + m.name + '.',
        'totalTime': 'PT' + Math.ceil((sb ? sb.total : 180) / 60) + 'M',
        'supply': [
          { '@type': 'HowToSupply', 'name': r.coffee + 'g cafea ' + o.name + ' proaspăt măcinată' },
          { '@type': 'HowToSupply', 'name': r.water + 'ml apă filtrată la ' + r.temp + '°C' }
        ],
        'tool': [{ '@type': 'HowToTool', 'name': m.name }],
        'step': steps.length ? steps : [
          { '@type': 'HowToStep', 'name': 'Pregătește', 'text': 'Pregătește echipamentul și măcina cafeaua.' },
          { '@type': 'HowToStep', 'name': 'Toarnă', 'text': 'Toarnă apa peste cafea conform metodei selectate.' }
        ]
      };
      var existing = document.getElementById('icHowToSchema');
      if (existing) existing.remove();
      var script = document.createElement('script');
      script.id = 'icHowToSchema';
      script.type = 'application/ld+json';
      script.textContent = JSON.stringify(schema);
      document.head.appendChild(script);
    }

    setTimeout(function() {
      injectTasteAdviceUI();
      updateTasteAdvice();
      updateHowToSchema();
    }, 300);
    setTimeout(function() { try { update(); } catch (e) {} }, 100);
  });
})();
